/* eslint-disable react-hooks/exhaustive-deps */

"use client";

import React, { useEffect } from "react";

import { useChat } from "@/src/hooks/useChat";
import { useChatFunctions } from "@/src/hooks/useChatFunctions";
import { getSocket } from "@/src/socket";

import { ChatBox } from "./ChatBox/ChatBox";
import { ConversationList } from "./conversation/ConversationList";

export function MyMessages(): JSX.Element {
  const socket = getSocket();
  const { selectedConversation, messages, conversations } = useChat();
  const { appendNewMessage, userStatusChanges, appendConversationToTop } =
    useChatFunctions();

  useEffect(() => {
    if (socket && socket.connected) {
      socket.on("broadcast_new_message", (newMessage) => {
        appendConversationToTop(newMessage);
      });
    }
    return () => {
      if (socket) {
        socket.off("broadcast_new_message");
      }
    };
  }, [socket, conversations, messages]);

  useEffect(() => {
    if (socket && socket.connected) {
      socket.on("deliver_chat_message", (newMessage) => {
        appendNewMessage(newMessage);
        appendConversationToTop(newMessage);
      });
    }
    return () => {
      if (socket) {
        socket.off("deliver_chat_message");
      }
    };
  }, [socket, messages, socket]);

  useEffect(() => {
    if (socket && socket.connected) {
      socket.on("user_online_status", (data) => {
        const { userId, online } = data;
        userStatusChanges(parseInt(userId), online);
      });
    }
    return () => {
      if (socket) {
        socket.off("user_online_status");
      }
    };
  }, [messages]);

  useEffect(() => {
    if (socket && socket.connected && selectedConversation) {
      socket.emit("subscribe_to_specific_conversation", {
        conversationId: selectedConversation.conversationId,
      });
    }
  }, [selectedConversation, socket]);

  return (
    <div className="flex gap-4">
      <ConversationList />
      <ChatBox />
    </div>
  );
}
